module.exports = __webpack_public_path__ + "static/media/image05.d22effc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/image05.jpg
// module id = 319
// module chunks = 0